import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { LANDING_PAGE } from '../../../routes/routes';

const StyledContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
}));

const StyledTypographyContent = styled(Typography)(() => ({
  fontSize: '0.9rem',
}));

const StyledTypographyErrorType = styled(Typography)(({ errorType }) => {
  const errorStyles = {
    403: {
      background: 'linear-gradient(10deg, #ffdb65, #ffa600)',
    },
    404: {
      background: 'linear-gradient(10deg, #e9e9e9, #808080)',
    },
    500: {
      background: 'linear-gradient(10deg, #82eefc, #008cff)',
    },
  };
  return {
    ...errorStyles[errorType],
    fontSize: '11rem',
    fontWeight: 200,
    color: 'transparent',
    backgroundClip: 'text',
    '-webkit-background-clip': 'text',
  };
});

const StyledTypographyTitle = styled(Typography)(() => ({
  fontSize: '2.8rem',
  marginTop: '-3.5rem',
}));

const Error = ({ error }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { type, title, content } = error;

  const goBack = () => navigate(-1);
  const goToLandingPage = () => navigate(LANDING_PAGE);
  const isHistoryStackEmpty = location.key === 'default';

  return (
    <StyledContainer>
      <StyledTypographyErrorType errorType={type}>
        {type}
      </StyledTypographyErrorType>
      <Box sx={{ textAlign: 'center' }}>
        <StyledTypographyTitle>{title.toUpperCase()}</StyledTypographyTitle>
        <Box sx={{ my: 2 }}>
          {content.map((item) => (
            <StyledTypographyContent key={item}>{item}</StyledTypographyContent>
          ))}
        </Box>
        <Box sx={{ my: 4 }}>
          {!isHistoryStackEmpty && (
            <Button
              aria-label="to previous page"
              onClick={goBack}
              variant="outlined"
              style={{ marginRight: '0.5rem' }}
            >
              {t('back', { ns: 'buttons' })}
            </Button>
          )}
          <Button aria-label="to landing page" onClick={goToLandingPage}>
            {t('backToHome', { ns: 'buttons' })}
          </Button>
        </Box>
      </Box>
    </StyledContainer>
  );
};

Error.propTypes = {
  error: PropTypes.object.isRequired,
};

export default Error;
